import {formatNumberCs, formatNumberEn} from '@fl/cmsch-fe-library';

import {languageStore} from './language-store';

/**
 * Returns a formatter that uses the current application language.
 *
 * @returns A number formatter configured for the current language.
 */
export const formatNumberByCurrentLanguage: () => (decimalPlaces: number) => (num: number) => string | null = () => {
    const language = languageStore.get() || 'CS';
    const numberFormatterFunction = language === 'CS' ? formatNumberCs : formatNumberEn;

    return numberFormatterFunction;
};
